const getImageFromNextImage = (url: string) => `/_next/image?url=${encodeURIComponent(url)}&w=156&q=75`

export default getImageFromNextImage
